/**
 * UC-33: UpdateOrgSimulation
 * TOGAF Application ABB — advances HR/TPRM/audit simulation state per game tick.
 */
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IOrgManagement } from '../../domain/ports/IOrgManagement';

export interface UpdateOrgSimulationDependencies {
  orgManagement: IOrgManagement;
  logger?: IAppLogger;
}

export interface UpdateOrgSimulationOutput {
  tick: number;
  employeeCount: number;
  vendorCount: number;
  activeAudits: number;
}

export class UpdateOrgSimulationUseCase {
  constructor(private readonly deps: UpdateOrgSimulationDependencies) {}

  execute(tickNumber: number): UpdateOrgSimulationOutput {
    this.deps.orgManagement.updateSimulation(tickNumber);

    const employees = this.deps.orgManagement.getEmployees();
    const vendors = this.deps.orgManagement.getVendors();
    const activeAudits = this.deps.orgManagement.getActiveAudits();

    this.deps.logger?.log('debug', 'org_simulation.updated', {
      tick: tickNumber,
      employeeCount: employees.length,
      vendorCount: vendors.length,
      activeAudits: activeAudits.length,
    });

    return {
      tick: tickNumber,
      employeeCount: employees.length,
      vendorCount: vendors.length,
      activeAudits: activeAudits.length,
    };
  }
}